module.exports = __webpack_public_path__ + "img/arrow-left.82e5a1b6.svg";